import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Admin() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/admin-login");
      return;
    }

    const fetchData = async () => {
      const res = await axios.get("/api/enquiries", {
        headers: { Authorization: token }
      });

      setData(res.data);
    };

    fetchData();
  }, [navigate]);

  // ✅ Logout function
  const logout = () => {
    localStorage.removeItem("token");
    navigate("/admin-login");
  };

  return (
    <div style={{ padding: "20px" }}>
      
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Enquiries</h2>

        <button
          onClick={logout}
          style={{
            padding: "8px 12px",
            cursor: "pointer",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "4px"
          }}
        >
          Logout
        </button>
      </div>

      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Mobile</th>
            <th>District</th>
            <th>City</th>
            <th>Date</th>

          </tr>
        </thead>

        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.mobile}</td>
              <td>{item.district}</td>
              <td>{item.city}</td>
              <td>{new Date(item.created_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Admin;
